import { StageType } from "../../../Assessment-Platform-1.0-Dtos-FE/src/enums/course/stageType.enum";
import { UserExamStatus } from "../../../Assessment-Platform-1.0-Dtos-FE/src/enums/userExamStatus.enum";
export const AllSubdomain = {
    app: {
        port: "3000",
        name: "app",
    },
    admin: {
        port: "3001",
        name: "admin",
    },
    wizard: {
        port: "3002",
        name: "wizard",
    },
    coderprep: {
        port: "3003",
        name: "coderprep",
    },
    inventory: {
        port: "3004",
        name: "inventory",
    },
    interviewprep: {
        port: "3007",
        name: "interviewprep",
    },
    bootcamp: {
        port: "3008",
        name: "bootcamp",
    },
    tenantUser: {
        port: "3009",
        name: "app",
    },
    tenantAdmin: {
        port: "3010",
        name: "admin",
    },
    tenantInterviewprep: {
        port: "3011",
        name: "interviewprep",
    },
    tenantCoderprep: {
        port: "3012",
        name: "coderprep",
    },
    tenantOnboarding: {
        port: "3013",
        name: "onboarding",
    },
    tenantAiCoach: {
        port: "3014",
        name: "analytics",
    },
};
export const ParentDomain = "refactor.academy";
export const CoderPrepSubdomain = [
    StageType.MCQ_EXAM,
    StageType.CODING_TEST,
    StageType.CODING_INTERVIEW,
];
export const InterviewPrepSubdomain = [
    StageType.BOT_INTERVIEW,
    StageType.INTERVIEW,
];
export const GetLocalPort = (stageType, isRefactor = false) => {
    if (CoderPrepSubdomain.includes(stageType)) {
        const subdomain = isRefactor
            ? AllSubdomain.coderprep
            : AllSubdomain.tenantCoderprep;
        return subdomain.port;
    }
    if (InterviewPrepSubdomain.includes(stageType)) {
        const subdomain = isRefactor
            ? AllSubdomain.interviewprep
            : AllSubdomain.tenantInterviewprep;
        return subdomain.port;
    }
};
export const GetSubdomain = (stageType) => {
    if (CoderPrepSubdomain.includes(stageType)) {
        return AllSubdomain.coderprep.name;
    }
    if (InterviewPrepSubdomain.includes(stageType)) {
        return AllSubdomain.interviewprep.name;
    }
};
export const CardColorCodes = [
    "#566573",
    "#CE76FE",
    "#ED6F71",
    "#00BCD4",
    "#FF9800",
    "#4CAF50",
];
export const ExamEligibleStatus = [
    UserExamStatus.ELIGIBLE,
    UserExamStatus.OUTSTANDING,
    UserExamStatus.EXCELLENT,
    UserExamStatus.ELIGIBLE_TRACK_1,
    UserExamStatus.ELIGIBLE_TRACK_2,
    UserExamStatus.ELIGIBLE_FOR_Hackathon,
];
export const ExamNotEligibleStatus = [
    UserExamStatus.NOT_ELIGIBLE,
];
export const getUserStageStatus = (status) => {
    if (ExamEligibleStatus.includes(status) ||
        ExamNotEligibleStatus.includes(status) ||
        status === UserExamStatus.APPLIED ||
        status === UserExamStatus.RESULT_CALCULATING) {
        return status;
    }
    else {
        return "Test Taken";
    }
};
export const getFullName = (firstName, lastName) => {
    let fullName = "";
    if (firstName && lastName) {
        fullName = firstName + " " + lastName;
    }
    else if (firstName) {
        fullName = firstName;
    }
    else if (lastName) {
        fullName = lastName;
    }
    return fullName;
};
